import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';

const UpitnikGrobnaMjesta: IModel = {
  title: 'Upitnici - grobna mjesta',
  apiPath: 'groblja/upitnici/grobna-mjesta',
  layer: 'grobna_mjesta',
  forms: {},
  listViews: {
    default: {
      fields: [
        'id',
        'groblje_id',
        'odjel',
        'razred',
        'polozaj',
        'polje',
        'red',
        'broj',
        'ima_obveznika',
        'upitnik_status',
        'upitnik_created_on',
        'broj_novih_odgovora',
      ],
      hidden: ['id', 'razred', 'polozaj'],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      filter: true,
    },
    {
      title: 'odjel',
      source: 'odjel',
      ttoken: 'groblja:grobna_mjesta.odjel',
      type: 'text',
      filter: true,
    },
    {
      title: 'razred',
      source: 'razred',
      ttoken: 'groblja:grobna_mjesta.razred',
      type: 'text',
      filter: true,
    },
    {
      title: 'polozaj',
      source: 'polozaj',
      ttoken: 'groblja:grobna_mjesta.polozaj',
      type: 'text',
      filter: true,
    },
    {
      title: 'polje',
      source: 'polje',
      ttoken: 'groblja:grobna_mjesta.polje',
      type: 'text',
      filter: true,
    },
    {
      title: 'red',
      source: 'red',
      ttoken: 'groblja:grobna_mjesta.red',
      type: 'text',
      filter: true,
    },
    {
      title: 'broj',
      source: 'broj',
      ttoken: 'groblja:grobna_mjesta.broj',
      type: 'text',
      filter: true,
    },
    {
      title: 'ima_obveznika',
      source: 'ima_obveznika',
      ttoken: 'groblja:upitnici.ima_obveznika',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'upitnik_status',
      source: 'upitnik_status',
      ttoken: 'groblja:upitnici.upitnik_status',
      type: 'picker',
      items: {
        labels: [
          'groblja:upitnici.statusi.nema',
          'groblja:upitnici.statusi.aktivan',
          'groblja:upitnici.statusi.zatvoren',
          'groblja:upitnici.statusi.preusmjeren',
          'groblja:upitnici.statusi.istekao',
        ],
        values: ['NEMA', 'AKTIVAN', 'ZATVOREN', 'PREUSMJEREN', 'ISTEKAO'],
      },
      filter: true,
      translate: true,
      readonly: true,
    },
    {
      title: 'upitnik_created_on',
      source: 'upitnik_created_on',
      ttoken: 'groblja:upitnici.upitnik_created_on',
      type: 'datetime',
      filter: true,
      readonly: true,
    },
    {
      title: 'broj_novih_odgovora',
      source: 'broj_novih_odgovora',
      ttoken: 'groblja:upitnici.broj_novih_odgovora',
      type: 'wholenum',
      filter: true,
      readonly: true,
    },
    // not shown, but DataController drops keys without a field and the slips need them
    {
      title: 'groblje_naziv',
      source: 'groblje_naziv',
      ttoken: 'groblja:upitnici.groblje',
      type: 'text',
      readonly: true,
    },
    {
      title: 'upitnik_gid',
      source: 'upitnik_gid',
      ttoken: '',
      type: 'text',
      readonly: true,
    },
    coreFields.geom,
  ],
};

export default UpitnikGrobnaMjesta;
